const scrollTop = () => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
}

export default scrollTop